/*
  Parcours devis RésineLab : le panier Shopify sert de liste de devis.
  - « Ajouter au devis » depuis une carte, une fiche, un méga-menu ou le tiroir ;
  - ouverture du tiroir avec bandeau de confirmation ;
  - modification des quantités et des conditionnements dans le tiroir ;
  - mise à jour du compteur et du total dans le header.
  Aucun bouton de paiement n'est appelé. JavaScript natif.
*/
(function () {
  'use strict';

  var DRAWER_SECTION = 'rl-quote-drawer';

  // Les sections à rafraîchir après chaque modification du devis. Une page peut
  // ajouter la sienne (voir rl-quote-request.js).
  window.rlSections = window.rlSections || [DRAWER_SECTION];

  function sectionsParam() {
    return window.rlSections.join(',');
  }

  function drawer() {
    return document.querySelector('[data-rl-drawer]');
  }

  /* ------------------------------------------------------------- Ouverture */

  var lastFocused = null;

  function openDrawer(message) {
    var el = drawer();
    if (!el) return;
    lastFocused = document.activeElement;

    var confirm = el.querySelector('[data-rl-drawer-confirm]');
    var text = el.querySelector('[data-rl-drawer-confirm-text]');
    if (confirm && text) {
      if (message) {
        text.textContent = message;
        confirm.hidden = false;
      } else {
        confirm.hidden = true;
      }
    }

    el.hidden = false;
    window.requestAnimationFrame(function () {
      el.setAttribute('data-open', 'true');
    });
    document.body.classList.add('rl-no-scroll');

    var closeButton = el.querySelector('[data-rl-drawer-close]');
    if (closeButton) closeButton.focus();
  }

  function closeDrawer() {
    var el = drawer();
    if (!el || el.hidden) return;
    el.setAttribute('data-open', 'false');
    document.body.classList.remove('rl-no-scroll');
    window.setTimeout(function () {
      el.hidden = true;
    }, 240);
    if (lastFocused) lastFocused.focus();
  }

  /* --------------------------------------------------- Rafraîchissement */

  // Coordonnées déjà saisies sur la page de devis (champs « contact[…] ») : elles survivent au
  // remplacement de la section quand une quantité ou un conditionnement change.
  function savedFields(el) {
    var values = {};
    Array.prototype.forEach.call(el.querySelectorAll('[name^="contact["]'), function (field) {
      if (field.type === 'hidden') return;
      values[field.name] = field.type === 'checkbox' ? field.checked : field.value;
    });
    return values;
  }

  function restoreFields(el, values) {
    Object.keys(values).forEach(function (name) {
      var field = el.querySelector('[name="' + name.replace(/"/g, '\\"') + '"]');
      if (!field) return;
      if (field.type === 'checkbox') field.checked = values[name];
      else field.value = values[name];
    });
  }

  function applySections(sections, message) {
    if (!sections) return;

    Object.keys(sections).forEach(function (key) {
      var html = sections[key];
      if (!html) return;
      var parsed = new DOMParser().parseFromString(html, 'text/html');

      if (key === DRAWER_SECTION) {
        var el = drawer();
        var fresh = parsed.querySelector('[data-rl-drawer]');
        if (!el || !fresh) return;
        var wasOpen = el.getAttribute('data-open') === 'true';
        el.innerHTML = fresh.innerHTML;
        if (wasOpen) el.setAttribute('data-open', 'true');
        syncHeader(el);

        if (message) {
          var confirm = el.querySelector('[data-rl-drawer-confirm]');
          var text = el.querySelector('[data-rl-drawer-confirm-text]');
          if (confirm && text) {
            text.textContent = message;
            confirm.hidden = false;
          }
        }
        return;
      }

      // Autres sections (page de demande de devis, panier…)
      var target = document.getElementById('shopify-section-' + key);
      var source = parsed.getElementById('shopify-section-' + key) || parsed.body.firstElementChild;
      if (target && source) {
        var values = savedFields(target);
        target.innerHTML = source.innerHTML;
        restoreFields(target, values);
      }
    });

    document.dispatchEvent(new CustomEvent('rl:cart:updated'));
  }

  function syncHeader(el) {
    var summary = (el || drawer() || document).querySelector('[data-rl-quote-summary]');
    if (!summary) return;

    var count = summary.getAttribute('data-count');
    var countLabel = summary.getAttribute('data-count-label');
    var total = summary.getAttribute('data-total');

    var bubble = document.querySelector('[data-rl-quote-count]');
    if (bubble) bubble.textContent = count;

    var label = document.querySelector('[data-rl-quote-count-label]');
    if (label) {
      var prefix = label.textContent.split('·')[0].trim();
      label.textContent = prefix + ' · ' + countLabel;
    }

    var totalEl = document.querySelector('[data-rl-quote-total]');
    if (totalEl && total) totalEl.textContent = total;
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw data;
        return data;
      });
    });
  }

  /* ------------------------------------------------------ Ajout au devis */

  function addFromForm(form) {
    var data = new FormData(form);
    var id = data.get('id');
    if (!id) return;

    var quantity = parseInt(data.get('quantity') || '1', 10);
    var properties = {};
    data.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match) properties[match[1]] = value;
    });

    var button = form.querySelector('button[type="submit"]');
    if (button) button.setAttribute('aria-disabled', 'true');

    post(window.routes ? window.routes.cart_add_url + '.js' : '/cart/add.js', {
      items: [{ id: Number(id), quantity: quantity, properties: properties }],
      sections: sectionsParam(),
    })
      .then(function (data) {
        var item = data.items ? data.items[0] : data;
        var title = item ? item.product_title : '';
        var variant = item && item.variant_title ? ' · ' + item.variant_title : '';
        var message = window.rlStrings
          ? window.rlStrings.added.replace('[title]', title + variant)
          : title + variant;
        applySections(data.sections, message);
        openDrawer(message);
      })
      .catch(function () {
        // En cas d'échec, on laisse le formulaire faire une soumission classique.
        form.submit();
      })
      .then(function () {
        if (button) button.removeAttribute('aria-disabled');
      });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-rl-quote-form]');
    if (!form) return;
    event.preventDefault();
    addFromForm(form);
  });

  /* ------------------------------------------ Ajouter tous les associés */

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-rl-add-all]');
    if (!button) return;
    event.preventDefault();

    var scope = button.closest('[data-rl-related]') || document;
    var items = [];
    Array.prototype.forEach.call(scope.querySelectorAll('[data-rl-quote-form]'), function (form) {
      var id = form.querySelector('[name="id"]');
      if (id && id.value) items.push({ id: Number(id.value), quantity: 1, properties: { _devis: 'true' } });
    });
    if (!items.length) return;

    post('/cart/add.js', { items: items, sections: sectionsParam() }).then(function (data) {
      applySections(data.sections);
      openDrawer();
    });
  });

  /* ------------------------------------------------- Lignes du tiroir */

  function changeLine(line, quantity) {
    return post('/cart/change.js', { line: Number(line), quantity: quantity, sections: sectionsParam() }).then(
      function (data) {
        applySections(data.sections);
        return data;
      }
    );
  }

  document.addEventListener('click', function (event) {
    var el = drawer();
    if (!el) return;

    if (event.target.closest('[data-rl-drawer-close]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    var remove = event.target.closest('[data-rl-line-remove]');
    if (remove) {
      event.preventDefault();
      changeLine(remove.getAttribute('data-line'), 0);
      return;
    }

    var step = event.target.closest('[data-rl-line-step]');
    if (step) {
      event.preventDefault();
      var input = el.querySelector('[data-rl-line-qty][data-line="' + step.getAttribute('data-line') + '"]');
      if (!input) return;
      var next = parseInt(input.value, 10) + parseInt(step.getAttribute('data-rl-qty-step') || step.getAttribute('data-rl-line-step'), 10);
      if (next < 0) next = 0;
      changeLine(step.getAttribute('data-line'), next);
    }
  });

  document.addEventListener('change', function (event) {
    var qty = event.target.closest('[data-rl-line-qty]');
    if (qty) {
      var value = parseInt(qty.value, 10);
      if (isNaN(value) || value < 0) value = 0;
      changeLine(qty.getAttribute('data-line'), value);
      return;
    }

    // Changement de conditionnement : on retire la ligne puis on ajoute la nouvelle variante.
    var variant = event.target.closest('[data-rl-line-variant]');
    if (variant) {
      var line = variant.getAttribute('data-line');
      var el = drawer();
      var input = el ? el.querySelector('[data-rl-line-qty][data-line="' + line + '"]') : null;
      var quantity = input ? parseInt(input.value, 10) || 1 : 1;
      var newId = Number(variant.value);

      changeLine(line, 0).then(function () {
        return post('/cart/add.js', {
          items: [{ id: newId, quantity: quantity, properties: { _devis: 'true' } }],
          sections: sectionsParam(),
        });
      }).then(function (data) {
        applySections(data.sections);
      });
    }
  });

  /* ------------------------------------------- Ouverture depuis le header */

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-rl-quote-toggle]');
    if (!toggle) return;
    if (!drawer()) return;
    event.preventDefault();
    openDrawer();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDrawer();
  });

  // Piège à tabulation dans le tiroir ouvert
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return;
    var el = drawer();
    if (!el || el.hidden) return;
    var items = Array.prototype.filter.call(
      el.querySelectorAll('a[href], button:not([disabled]), input, select, textarea'),
      function (node) {
        return node.offsetParent !== null;
      }
    );
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  /* ----------------------------------- Pastilles de conditionnement (cartes) */

  document.addEventListener('click', function (event) {
    var option = event.target.closest('[data-rl-card-option]');
    if (!option) return;
    event.preventDefault();

    var card = option.closest('[data-rl-card]');
    if (!card) return;

    Array.prototype.forEach.call(card.querySelectorAll('[data-rl-card-option]'), function (other) {
      var active = other === option;
      other.classList.toggle('rl-card__option--active', active);
      other.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    var input = card.querySelector('[data-rl-variant-input]');
    if (input) input.value = option.getAttribute('data-variant-id');

    var amount = card.querySelector('[data-rl-card-price] .rl-price__amount');
    if (amount) amount.textContent = option.getAttribute('data-price');
    var alt = card.querySelector('[data-rl-card-price] .rl-price__alt');
    if (alt && option.hasAttribute('data-price-alt')) alt.textContent = option.getAttribute('data-price-alt');
    // Format sur devis : mention de TVA retirée et typographie « sur devis » (les autres formats gardent la leur)
    var tax = card.querySelector('[data-rl-card-price] .rl-price__tax');
    if (tax && option.hasAttribute('data-price-tax')) tax.textContent = option.getAttribute('data-price-tax');
    var bloc = card.querySelector('[data-rl-card-price] .rl-price');
    if (bloc) bloc.classList.toggle('rl-price--quote', option.getAttribute('data-quote') === 'true');
    // Nom du format (affiché en mobile, où les pastilles sont masquées) et rappel « autres formats dès … »
    var name = card.querySelector('[data-rl-card-variant]');
    if (name) name.textContent = option.getAttribute('data-title') || '';
    var from = card.querySelector('[data-rl-card-from]');
    if (from) from.hidden = option.getAttribute('data-cheapest') === 'true';
  });

  syncHeader();

  // Pour la page de demande de devis : rafraîchir le tiroir et le header après envoi.
  window.rlQuoteApply = applySections;
})();
